import { __rest } from "tslib";
import * as React from 'react';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import styles from '@patternfly/react-styles/css/components/Breadcrumb/breadcrumb';
import { css } from '@patternfly/react-styles';
export var BreadcrumbItem = function BreadcrumbItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$to = _a.to,
      to = _a$to === void 0 ? null : _a$to,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$target = _a.target,
      target = _a$target === void 0 ? null : _a$target,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'a' : _a$component,
      props = __rest(_a, ["children", "className", "to", "isActive", "target", "component"]);

  var Component = component;
  return React.createElement("li", Object.assign({}, props, {
    className: css(styles.breadcrumbItem, className)
  }), to && React.createElement(Component, {
    href: to,
    target: target,
    className: css(styles.breadcrumbLink, isActive && styles.modifiers.current),
    "aria-current": isActive ? 'page' : undefined
  }, children), !to && React.createElement(React.Fragment, null, children), !isActive && React.createElement("span", {
    className: css(styles.breadcrumbItemDivider)
  }, React.createElement(AngleRightIcon, null)));
};